var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"u-scan flex"},[_c('div',{staticClass:"flex-grow"},[_vm._t("default")],2),((_vm.testData || _vm.scanAuth) && !_vm.disabled)?_c('div',{staticClass:"u-scan-button flex-center",on:{"click":_vm.scanHandle}},[_c('i',{staticClass:"tf-scan"})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }